import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import {AuthenticationDefaultSteps} from "../../tools/defaults/authentication/UserAuthentication";
import UserAuthenticationContext from "../../tools/contexts/authenticatonService/UserAuthenticationContext";
import {StreamManager} from "../../tools/contexts/StreamManager";
import NIDCardReader from "../../components/userAuthentication/NIDCardReader";
import CompareFaces from "../../components/userAuthentication/CompareFaces";
import VideoValidation from "../../components/userAuthentication/VideoValidation";
import Final from "../../components/userAuthentication/Final";
import LoadingScreen from "../../components/LoadingScreen";
import UserReportedCard from "../../components/userAuthentication/UserReportedCard";
import InitConfirm from "../../components/userAuthentication/InitConfirm";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import CreatePayment from "../../components/userAuthentication/CreatePayment";
import useDivarAuth from "../../hooks/useDivarAuth";

const UserAuthentication = () => {
    const navigate=useNavigate();
    const {token,ticketUuid,postToken,returnUrl,serviceType}=useDivarAuth();
    const [pid, setPid] = useState(null);
    const [isLoading, setIsLoading] = useState({
        showLoading: false,
        text: 'لطفا منتظر بمانید'
    });
    const [process, setProcess] = useState(null);
    const [components, setComponents] = useState(null);
    const [reported, setReported] = useState(false);
    const [reportedMessage, setReportedMessage] = useState('');
    const [status, setStatus] = useState(null);
    useEffect(() => {
        handleInquiryProcess()
    }, []);
    const handleRedirectToDivar = ({price, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        },true);
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText:'بستن',
                onCancel:()=>{
                    Reoverlay.hideModal();
                    navigate('/404')

                }
            })
        })
    }
    const handleProcess = (newProcess) => {
        setProcess(newProcess)
    }
    const handleLoading = (newLoading) => {
        setIsLoading(newLoading)
    }
    const handleUpdateStep = (newStep, passedStep) => {
        if (passedStep) {
            let passedSteps = [...process.passed_steps, passedStep];

            const newState = {
                ...process,
                current_step: newStep,
                passed_steps: passedSteps,
            }

            setProcess(newState)
        } else {
            const newState = {
                ...process,
                current_step: newStep
            }

            setProcess(newState)
        }
    };
    const handleGenerateCreateProcessParams = () => {
        const pattern = /^vm_/;
        const hasPostAddon = sessionStorage.getItem('has_post_addon');
        const hasUserAddon = sessionStorage.getItem('has_user_addon');
        const isGeneratedTicketUuid = pattern.test(ticketUuid);
        if (isGeneratedTicketUuid) {
            //ticket id generated by sdk
            return {
                'action': 'non+uuid',
                'post_token': ticketUuid
            }
        } else {
            //ticket id send by divar
            if (hasUserAddon && hasUserAddon==='1') {
                // create user Addon widget
                return {
                    'action': 'uuid+ua+wg',
                    'post_token': ticketUuid
                }
            } else if (hasPostAddon && hasPostAddon === '1') {
                // create post Addon widget

                return {
                    'action': 'uuid+wg',
                    'post_token': ticketUuid,
                    'ad_post_token': postToken,
                }
            }else {
                return {
                    'action': 'uuid+non+wg',
                    'post_token': ticketUuid
                }
            }

        }
    }
    const handleCreateProcess = () => {
        setIsLoading({
            showLoading: true,
            text: 'در حال ساخت فرایند'
        });
        const params = handleGenerateCreateProcessParams();
        Api.post(REQUEST_URLS.DIVAR_INTERNAL_AUTH.CREATE_PROCESS, params, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;

            if (hasError) {
                setIsLoading(false)
                handleError({
                    data, status, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: status === 845 ? 'بازگشت به دیوار' : 'تلاش مجدد',
                            cancelButtonTheme: status === 845 ? "light" : 'red',
                            onCancel: () => {
                                if (status === 845) {
                                    handleRedirectToDivar({status: 'fail', price: 0})
                                } else {
                                    handleCreateProcess();
                                }

                            }
                        })
                    }
                })
            } else {
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })
                setPid(data.pid);
                handleGetProcess(data.pid)
            }
        }).catch(e => {
            console.log(e)
        }).finally(() => {

        })
    }
    const handleInquiryProcess = () => {
        setIsLoading({
            showLoading: true,
            text: 'در حال دریافت اطلاعات'
        });
        console.log({
            post_token: ticketUuid,
            service_type: serviceType,
        })
        Api.get(REQUEST_URLS.DIVAR_INTERNAL_AUTH.INQUIRY_PROCESS, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            params: {
                post_token: ticketUuid,
                service_type: serviceType
            }
        }).then(response => {
            const {status, data, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })

                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    setPid(data.process.pid);
                    if (data?.process?.status && data?.process.status === "rejected") {
                        handleCreateProcess();
                    } else {
                        handleGetProcess(data.process.pid)
                    }
                } else {
                    handleCreateProcess();
                }
            }
        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleShahkar = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال تطابق کد ملی و شماره موبایل'
        })
        handleGenerateUuid('Shahkar', token).then(data => {
            setIsLoading({
                showLoading: true,
                text: 'در حال تطابق کد ملی و شماره موبایل'
            })
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_AUTH.SHAHKAR, {
                pid: newPid,
                uuid: data,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(newPid)

                } else {
                    setIsLoading({
                        showLoading: false,
                        text: 'در حال دریافت اطلاعات'
                    })

                    handleError({
                        message,
                        status,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای دسترسی',
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                confirmButtonTheme: "light",
                                showCancelButton: status !== 360,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                pid: newPid,
                                onConfirm: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid);
                                    }
                                    Reoverlay.hideModal();
                                },
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    handleShahkar(newPid);
                                }
                            })
                        }
                    })


                }

            }).catch(() => {
                handleLoading(false)
            }).finally(() => {


            })

        }).catch(error => {
            console.log(error);
            handleLoading(false)
        });

    }
    const handleAutoNIDCard = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال استعلام'
        })
        handleGenerateUuid('AutoNIDCard', token).then(uuid => {
            setIsLoading({
                showLoading: true,
                text: 'در حال استعلام'
            })
            Api.post(REQUEST_URLS.DIVAR_INTERNAL_AUTH.AUTO_NID_CARD, {
                pid: newPid,
                uuid: uuid,
            }).then((response) => {
                const {data, hasError, status, message} = response;
                if (!hasError) {
                    handleGetProcess(newPid)
                } else {
                    handleLoading(false)
                    handleError({
                        message,
                        status,
                        data,
                        callback: () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: message || 'خطای دسترسی',
                                showConfirmButton: data?.can_reset,
                                confirmButtonText: 'ویرایش اطلاعات',
                                confirmButtonTheme: "light",
                                showCancelButton: true,
                                cancelButtonText: 'تلاش مجدد',
                                cancelButtonTheme: 'red',
                                pid: newPid,
                                onConfirm: () => {
                                    if (data.can_reset) {
                                        handleReset(newPid);
                                    }
                                    Reoverlay.hideModal();
                                },
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    handleAutoNIDCard(newPid);
                                }
                            })
                        }
                    })
                }

            }).catch(() => {
                handleLoading(false)
            }).finally(() => {


            })

        }).catch(error => {
            console.log(error);
            handleLoading(false)
        });
    }
    const handleGetProcess = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال دریافت اطلاعات'
        })

        Api.get(REQUEST_URLS.DIVAR_INTERNAL_AUTH.FETCH_PROCESS, {
            params: {
                pid: newPid,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {

                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleGetProcess(newPid);
                            }
                        })
                    }
                })
            } else {
                setComponents(data.components)
                setProcess(data.process);
                if (data.components.current_component.name === AuthenticationDefaultSteps.SHAHKAR) {
                    handleShahkar(newPid);
                } else if (data.components.current_component.name === AuthenticationDefaultSteps.AUTO_NID_CARD) {
                    handleAutoNIDCard(newPid)
                } else {
                    setIsLoading({
                        showLoading: false,
                        text: 'در حال دریافت اطلاعات'
                    })
                }

            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleError = ({ message,status,  callback}) => {
        if (status === -10) {
            setIsLoading({
                showLoading: false,
                text: ''
            })
            setReported(true)
            setStatus('fail')
            setReportedMessage(message)
        } else if (status === -11) {
            setIsLoading({
                showLoading: false,
                text: ''
            })
            setReported(true)
            setStatus('pending')
            setReportedMessage(message)
        } else if (status === -12) {
            setIsLoading({
                showLoading: false,
                text: ''
            })
            setStatus('success')
            setReported(true)
            setReportedMessage(message)
        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'بستن',
                cancelButtonTheme: 'red',

                onCancel: () => {


                }
            })

        } else if (status === 403 || status === 401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'دریافت دسترسی ',
                cancelButtonTheme: 'red',

                onCancel: () => {
                   handleRedirectToDivar({price:0,status:'fail'})

                }
            })
        }/*else if(data && data?.can_reset){
            handleReset(pid)
        }*/ else if (status === 801 || status === 802 || status === 803 || status === 805) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    handleCreateProcess();
                }
            })
        } else {
            callback()
        }
    }
    const handleComponents = (newComponents) => {
        setComponents(newComponents)
    }
    const handleReset = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'لطفا منتظر بمانید'
        })
        Api.post(REQUEST_URLS.DIVAR_INTERNAL_AUTH.RESET_PROCESS, {
            pid: newPid,
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {hasError, data, message, status} = response;
            if (hasError) {
                handleError({
                    status,
                    message,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleReset(newPid);
                                Reoverlay.hideModal();
                            }
                        })
                    }
                })
            } else {
                handleGetProcess(newPid)
            }
        }).finally(() => {

        })
    }
    return <div>
        <UserAuthenticationContext.Provider value={
            {
                postToken,
                isLoading,
                pid,
                token,
                process,
                components,
                handleLoading,
                handleUpdateStep,
                handleProcess,
                handleError,
                handleComponents,
                handleGetProcess,
                handleCreateProcess,
                handleReset,
                handleRedirectToDivar,

            }
        }>

            {reported && <UserReportedCard status={status}
                                           title={status === "pending" ? "در حال بررسی" : status === "success" ? "موفق" : 'شما مجاز به بررسی هویت نمی باشید.'}
                                           message={reportedMessage}/>}
            {isLoading && isLoading.showLoading && <LoadingScreen text={isLoading.text}/>}
            {!reported && <>
                {process && components?.current_component?.name === AuthenticationDefaultSteps.INIT_CONFIRM &&
                    <InitConfirm/>}
                {process && components?.current_component?.name === AuthenticationDefaultSteps.CREATE_PAYMENT &&
                    <CreatePayment/>}
                <StreamManager>
                    {process && components?.current_component?.name === AuthenticationDefaultSteps.NID_CARD_READER &&
                        <NIDCardReader/>}
                    {process && components?.current_component?.name === AuthenticationDefaultSteps.COMPARE_FACES &&
                        <CompareFaces/>}
                    {process && components?.current_component?.name === AuthenticationDefaultSteps.VIDEO_VALIDATION &&
                        <VideoValidation/>}
                </StreamManager>
                {process && components?.current_component?.name === AuthenticationDefaultSteps.FINAL && <Final/>}
            </>}
        </UserAuthenticationContext.Provider>
    </div>
}
export default UserAuthentication;